module.exports = __webpack_public_path__ + "img/t_wxed.906c230f.png";